module.exports = __webpack_public_path__ + "static/31import-33a5d8d908bdbf367bbd6e928a9fe634.png";